import { Corporation, FacilityStructure } from '../../../models/rpm/corporation.model'
import {ReportData} from "../../../models/rpm/monthly-notification.model";

export interface RpmPageState {
    corporations: Corporation[];
    facilities: FacilityStructure[];
    report: { [reportId: string]: ReportData };
}

export const initialRpmState: RpmPageState = {
    corporations: [],
    facilities: [],
    report: {}
}
